import { WithBrowseButtons } from "./withBrowseButtons";

export const ComboboxCompositions = {
    WithBrowseButtons,
} as const;

export type { WithBrowseButtonsProps as ComboboxWithBrowseButtonsProps } from "./withBrowseButtons";
